import styled from 'styled-components';
import { LoaderWidget as Loader } from '@jarvis/react-portal-addons';
import primitives from '@veneer/primitives';

export const StatusListContainer = styled.div`
  min-height: 228px;
  box-sizing: border-box;
`;

export const ContentArea = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 228px;
  margin-top: 0;
  justify-content: start;
  flex-direction: column;
  overflow-y: hidden;
`;

export const SubHeader = styled.div`
  :hover {
    cursor: pointer;
    background-color: ${primitives.color.gray2};
  }

  border-bottom: 1px solid ${primitives.color.gray3};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${primitives.layout.size6}px;
  height: 72px;
`;

export const SubHeaderTitle = styled.p`
  display: flex;
  color: ${primitives.color.gray12};
`;

export const Counter = styled.p`
  color: ${primitives.color.gray9};
`;

export const ArrowButton = styled.div`
  :hover {
    cursor: pointer;
    background-color: ${primitives.color.gray2};
  }

  width: ${primitives.layout.size5}px;
  display: flex;
  align-items: center;
  justify-items: center;
`;

export const ButtonArea = styled.div`
  max-width: 40%;
  display: flex;
  align-items: center;
  gap: ${primitives.layout.size3}px;
`;

export const AddonsWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 10px 0;
  overflow-y: hidden;
`;

export const LoaderWidget = styled(Loader)`
  && {
    min-width: 70px;
    overflow-y: hidden;
  }
`;

export const LoaderListContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 15% 0;
  overflow-y: hidden;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 10% 0;
  overflow-y: hidden;
`;
